module.exports = __webpack_public_path__ + "static/media/mental_wellness.737b3185.svg";